import React, { memo } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Grid, Typography } from '@mui/material';

import { useMutedCallback } from 'hooks/useMutedCallback';

import EmptyPromotionsListIcon from './icons/EmptyPromotionsListIcon';

export interface EmptyPromotionsListFCProps {
  onClick: () => void;
  strings: Record<'title' | 'subtitle' | 'addPromotions', string>;
  canSelfAssignCampaigns: boolean;
}

export const EmptyPromotionsListFC: React.FC<EmptyPromotionsListFCProps> = memo(
  ({ onClick, strings, canSelfAssignCampaigns }) => {
    const onClickHandler = useMutedCallback(onClick);

    return (
      <Grid>
        <Grid item xs={12}>
          <Box px={3}>
            <Box>
              <Box textAlign="center" mb={2.75}>
                <EmptyPromotionsListIcon />
              </Box>
              <Box textAlign="center" mb={1}>
                <Typography variant="h6" color="textPrimary">
                  {strings.title}
                </Typography>
              </Box>
              <Box textAlign="center" mb={3}>
                <Typography variant="bodyM" color="textSecondary">
                  {strings.subtitle}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box textAlign="center">
            {canSelfAssignCampaigns && (
              <Button
                onClick={onClickHandler}
                startIcon={<AddIcon />}
                variant="contained"
                color="primary"
                type="submit"
              >
                {strings.addPromotions}
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    );
  },
);
